import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const webhookSenderErrorTypeValues = [
  "PROJECT_NOT_FOUND",
  "BID_NOT_FOUND",
  "CONVERSATION_ITEM_NOT_FOUND",
  "QUOTE_NOT_FOUND",
  "TASK_NOT_FOUND",
  "MISSING_DATE",
] as const;
const webhookSenderErrorTypeSchema = z.enum(webhookSenderErrorTypeValues);
const WebhookSenderErrorType = webhookSenderErrorTypeSchema.enum;
type WebhookSenderErrorType = z.infer<typeof webhookSenderErrorTypeSchema>;

export type WebhookSenderErrors =
  | { errorType: typeof WebhookSenderErrorType.PROJECT_NOT_FOUND; data: { projectId: number } }
  | {
      errorType: typeof WebhookSenderErrorType.BID_NOT_FOUND;
      data: { bidId?: number; bidProjectId?: number; projectId?: number; taskId?: string; conversationItemId?: string };
    }
  | { errorType: typeof WebhookSenderErrorType.CONVERSATION_ITEM_NOT_FOUND; data: { conversationItemId: string } }
  | { errorType: typeof WebhookSenderErrorType.QUOTE_NOT_FOUND; data: { bidQuoteId: string } }
  | { errorType: typeof WebhookSenderErrorType.TASK_NOT_FOUND; data: { taskId: string } }
  | {
      errorType: typeof WebhookSenderErrorType.MISSING_DATE;
      data: { bidId?: number; taskId?: string; projectId?: number; dateType: string };
    };

export const webhookSenderErrorDetails: Record<WebhookSenderErrorType, ErrorDetails> = {
  PROJECT_NOT_FOUND: { classification: ErrorClassification.NOT_FOUND_ERROR, sentryDescription: "Project not found" },
  BID_NOT_FOUND: { classification: ErrorClassification.NOT_FOUND_ERROR, sentryDescription: "Bid not found" },
  CONVERSATION_ITEM_NOT_FOUND: {
    classification: ErrorClassification.NOT_FOUND_ERROR,
    sentryDescription: "Conversation item not found",
  },
  QUOTE_NOT_FOUND: { classification: ErrorClassification.NOT_FOUND_ERROR, sentryDescription: "Quote not found" },
  TASK_NOT_FOUND: { classification: ErrorClassification.NOT_FOUND_ERROR, sentryDescription: "Task not found" },
  MISSING_DATE: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Required date is missing",
  },
};
